import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: [
      "When you contact BTM Tech Developments through this website, we collect the information you provide directly: your name, email address, and the contents of your message.",
      "We may also collect limited technical information automatically when you visit the site, such as your browser type, device type, and approximate region, used solely to understand how the site is used and to improve it.",
    ],
  },
  {
    title: "2. How We Use Your Information",
    body: [
      "We use the information you provide to respond to your enquiry, discuss potential projects, and communicate with you about our services.",
      "We do not sell, rent, or trade your personal information to third parties. We do not use your information for advertising profiling.",
    ],
  },
  {
    title: "3. Client & Project Confidentiality",
    body: [
      "Ideas, materials, and project details you share with us are treated as confidential. We are happy to sign a non-disclosure agreement (NDA) before you share sensitive details about your product or business.",
      "Client data accessed during a development engagement is used only to deliver the agreed services and is never shared outside the engagement without written consent.",
    ],
  },
  {
    title: "4. Data Storage & Security",
    body: [
      "Contact form submissions are stored securely in our systems and retained only as long as needed to respond to your enquiry and maintain our business records.",
      "We apply reasonable technical and organizational safeguards to protect personal information against unauthorized access, loss, or disclosure. No method of transmission over the internet is 100% secure, but we work to protect your information to industry standards.",
    ],
  },
  {
    title: "5. Third-Party Services",
    body: [
      "This website is hosted on third-party infrastructure and may use privacy-respecting analytics to understand site traffic. These providers process data only as needed to deliver their services and are bound by their own privacy obligations.",
      "Our website may contain links to external sites. We are not responsible for the privacy practices of those sites.",
    ],
  },
  {
    title: "6. Cookies",
    body: [
      "This site may use essential cookies or similar technologies required for core functionality and anonymous usage measurement. You can control or delete cookies through your browser settings at any time.",
    ],
  },
  {
    title: "7. Your Rights",
    body: [
      "Under Alberta's Personal Information Protection Act (PIPA) and other applicable Canadian privacy laws, you have the right to request access to the personal information we hold about you, to request a correction, or to ask us to delete it.",
      "To exercise any of these rights, contact us using the details below. We will respond within a reasonable timeframe.",
    ],
  },
  {
    title: "8. Changes to This Policy",
    body: [
      "We may update this Privacy Policy from time to time. The current version will always be posted on this page with its effective date.",
    ],
  },
  {
    title: "9. Contact Us",
    body: [
      "If you have questions about this Privacy Policy or how your information is handled, contact:",
    ],
    contact: true,
  },
];

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-view" className="bg-[#121316] text-zinc-50 min-h-screen">
      <Navbar />
      <main className="pt-[72px]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
          <Reveal>
            <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-teal-400">
              Legal
            </p>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-zinc-50">
              Privacy Policy
            </h1>
            <p className="mt-4 text-sm text-zinc-500 font-mono uppercase tracking-wider">
              Effective date: July 1, 2026 · BTM Tech Developments, Calgary, Alberta
            </p>
            <p className="mt-8 text-base text-zinc-400 leading-relaxed">
              BTM Tech Developments ("we", "us", "our") respects your privacy. This policy explains
              what information we collect through this website and our development services, how we
              use it, and the choices you have.
            </p>
          </Reveal>

          <div className="mt-14 space-y-12">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={Math.min(i * 0.04, 0.2)}>
                <section data-testid={`privacy-section-${i + 1}`}>
                  <h2 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-zinc-50">
                    {s.title}
                  </h2>
                  <div className="mt-4 space-y-4">
                    {s.body.map((p, j) => (
                      <p key={j} className="text-sm sm:text-base text-zinc-400 leading-relaxed">
                        {p}
                      </p>
                    ))}
                  </div>
                  {s.contact && (
                    <div className="mt-5 bg-[#1A1B20] border border-zinc-800 rounded-xl p-6">
                      <p className="text-sm font-semibold text-zinc-100">Trinity Robertson</p>
                      <p className="text-sm text-zinc-400 mt-1">BTM Tech Developments — Calgary, Alberta, Canada</p>
                      <a
                        href="mailto:sales@btmtechdevelopments.com"
                        data-testid="privacy-email-link"
                        className="inline-block mt-2 text-sm text-teal-400 hover:text-teal-300 underline underline-offset-2"
                      >
                        sales@btmtechdevelopments.com
                      </a>
                    </div>
                  )}
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
